import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { TYPOGRAPHY } from "@store/theme/common/design";
import polyfillCss from "@store/theme/common/polyfillCss";

export default {
    defaultProps: {
        css: polyfillCss`
            display: flex;
            line-height: ${TYPOGRAPHY.lineHeight.small};

            input {
                position: absolute;
                clip: rect(0, 0, 0, 0);
                &:focus {
                    clip: unset;
                }

                & + label {
                    padding-left: 2.25em;
                    margin: 0;
                    cursor: pointer;

                    &::before, &::after {
                        font-size: ${TYPOGRAPHY.size.base};
                    }

                    &::before {
                        content: "";
                        position: absolute;
                        top: 50%;
                        left: 0;
                        display: block;
                        background-color: ${getColor("common.background")};
                        width: 1.25em;
                        height: 1.25em;
                        border-color: ${getColor("tertiary")};
                        border-width: 2px;
                        margin-right: 0.7em;
                        transform: translateY(-50%);
                    }
                }

                &:focus + label::before {
                    box-shadow: 0 0 0 2px ${getProp("theme.focus.color")};
                }

                &:hover:not(:disabled) + label::before {
                    border-color: ${getColor("secondary")};
                }

                &:checked + label::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    display: block;
                    left: calc((1.25em / 2) - 0.65em);
                    width: 0.65em;
                    height: 0.65em;
                    transform: translate(50%, -50%);
                }

                &:checked:not(:disabled) + label::before {
                    border-color: ${getColor("secondary")};
                    background: ${getColor("common.background")};
                }

                &:checked:not(:disabled) + label::after {
                    background: ${getColor("secondary")};
                }

                &:checked:disabled + label, &:disabled + label {
                    &::before {
                        border-color: ${getColor("common.border")};
                    }

                    &::after {
                        background: ${getColor("common.disabledLight")};
                    }
                }
            }
        `,
    },
};
